import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from "@ng-select/ng-select";
import { TranslocoModule, TranslocoService } from "@ngneat/transloco";
import { ICreateRoutingItinerary } from "./interfaces/create-routing-itinerary.interface";
import { RoutingItineraryTypesEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/routing-itinerary-types.enum";
import { RoutingItineraryService } from "./routing-itinerary.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: 'app-routing-itinerary.component',
  styleUrl: './routing-itinerary.component.scss',
  templateUrl: './routing-itinerary.component.html',
  standalone: true,
  imports: [
    TranslocoModule,
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
  ],
})

export class RoutingItinerary {
  currentCreateRoutingItinerary: ICreateRoutingItinerary = this.initializeCreateSubRouteItineraryV2();
  
  range!: FormGroup;

  constructor(
    private translocoService: TranslocoService,
    private snackBar: MatSnackBar,
    private readonly routingItineraryService: RoutingItineraryService,
    public dialogRef: MatDialogRef<RoutingItinerary>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngAfterViewInit(): void {
  }

  ngOnInit() {
    this.initializeForm();
  }

  private initializeCreateSubRouteItineraryV2(): ICreateRoutingItinerary {
    return {
        type: null,
        subRouteId: null,
        dateTimeStart: new Date(),
        dateTimeEnd: new Date(),
        detail:[]
    }
  }

  private initializeForm() {
    this.range = new FormGroup({
      start: new FormControl<Date | null>(null),
      end: new FormControl<Date | null>(null),
    });

    this.range.valueChanges.subscribe(value => {
      if (value.start && value.end) {
        this.currentCreateRoutingItinerary.dateTimeStart = new Date(value.start);
        this.currentCreateRoutingItinerary.dateTimeEnd = new Date(value.end);
      }
    });
  }

  private updateFormValues() {
    this.range.setValue({
      start: this.currentCreateRoutingItinerary?.dateTimeStart ?? null,
      end: this.currentCreateRoutingItinerary?.dateTimeEnd ?? null,
    }, { emitEvent: false }); 
  }

  submitForm() {
    if (this.range.valid && this.range.value.start && this.range.value.end) {
      this.currentCreateRoutingItinerary = {
        ...this.currentCreateRoutingItinerary,
        dateTimeStart: new Date(this.range.value.start), 
        dateTimeEnd: new Date(this.range.value.end), 
      };

      if(this.data.type == 1){
        this.currentCreateRoutingItinerary.type = RoutingItineraryTypesEnum.SUB_ROUTE;      this.currentCreateRoutingItinerary.subRouteId = this.data.subRouteId.toString()
        this.currentCreateRoutingItinerary.subRouteId = this.data.subRouteId.toString()
      }
      if(this.data.type == 2){
        this.currentCreateRoutingItinerary.type = RoutingItineraryTypesEnum.SUB_ROUTE_ALTERNATIVE;
        this.currentCreateRoutingItinerary.subRouteId = this.data.subRouteId.toString()
      }
      if(this.data.type == 3){
        this.currentCreateRoutingItinerary.type = RoutingItineraryTypesEnum.ROUTE_GROUP;
        this.currentCreateRoutingItinerary.routeGroupId = this.data.subRouteId.toString()
      }
      if(this.data.type == 4){
        this.currentCreateRoutingItinerary.type = RoutingItineraryTypesEnum.ROUTE_GROUP_ALTERNATIVE;
        this.currentCreateRoutingItinerary.routeGroupId = this.data.subRouteId.toString()
      }
      
      this.routingItineraryService.create(this.currentCreateRoutingItinerary).subscribe({
        next: () => {
          this.snackBar.open("Registro(s) creado(s) con éxito", "Cerrar", { duration: 5000, verticalPosition: "top" });
          this.dialogRef.close(this.currentCreateRoutingItinerary);
          /*if(type == 1){
            this.getRoutingItineraryByType(RoutingItineraryTypesEnum.SUB_ROUTE);
          }else{
            this.getRoutingItineraryByType(RoutingItineraryTypesEnum.SUB_ROUTE_ALTERNATIVE)
          }*/
        },
        error: (err) => {
          
        }
      })
    } else {
      this.snackBar.open("Debe seleccionar ambas fechas.","Cerrar",{ duration: 5000});      
    }
  }
}